import { useEffect } from "react";
import { Box, Button, Container, Tooltip, Typography } from "@material-ui/core";
import dayjs from "dayjs";
import { NavLink as RouterLink } from "react-router-dom";
import { XSquare as XSquareIcon } from "react-feather";
import useCapitalManagement from "../hooks/useCapitalManagement";
import Title from "../components/common/title";
// import CapitalDetail from "./CapitalDetail";
import CapitalAdd from "./CapitalAdd";
import CustomTable from "../components/common/CustomTable";
import CapitalEdit from "./CapitalEdit";
import CustomLinearProgress from "../components/common/CustomLinearProgress";
import ConfirmationDialog from "../components/common/ConfirmationDialog";

const investTypes = {
  invest: "Đầu tư"
};
const Capital = () => {
  const {
    loading,
    list = [],
    getList,
    handleClose,
    open,
    // handleOpenDetail,
    handleOpen,
    openEdit,
    dataEdit,
    handleCloseEdit,
    openModalDelete,
    deleteId,
    remove,
    deleteModalContent,
    handleCloseModalDelete,
    handleOpenModalDelete
  } = useCapitalManagement();

  useEffect(() => {
    getList();
  }, []);

  const handleDelete = (event, title, id) => {
    event.preventDefault();
    handleOpenModalDelete(title, id);
  };

  const options = {
    filterType: "checkbox",
    selectableRows: false
  };
  const getIsLatestRow = tableMeta => {
    const { rowIndex, tableData } = tableMeta;
    return rowIndex + 1 === tableData.length;
  };
  const columns = [
    {
      name: "status",
      label: "",
      options: {
        display: false,
        filter: false
      }
    },
    {
      name: "id",
      label: "#",
      options: {
        customBodyRender: (value, tableMeta) => {
          const status = tableMeta.rowData[0];
          const className = status === "cancel" ? "line-through" : "";
          const isLatestRow = getIsLatestRow(tableMeta);
          const { rowIndex } = tableMeta;
          const valueText = isLatestRow ? "" : rowIndex + 1;
          return <Box className={className}>{valueText}</Box>;
        }
      }
    },
    {
      name: "userId",
      label: "Khách hàng",
      options: {
        customBodyRender: (value, tableMeta) => {
          const status = tableMeta.rowData[0];
          const className = status === "cancel" ? "line-through" : "";
          const isLatestRow = getIsLatestRow(tableMeta);
          const valueText = isLatestRow ? "Tổng Tiền" : value;
          return (
            <Box
              className={className}
              sx={{
                color: isLatestRow ? "text.warning" : "",
                fontWeight: isLatestRow ? "bold" : "normal"
              }}
            >
              {valueText}
            </Box>
          );
        }
      }
    },
    {
      name: "amount",
      label: "Số tiền (VNĐ)",
      hasFilter: false,
      options: {
        customBodyRender: (value, tableMeta) => {
          const status = tableMeta.rowData[0];
          const className = status === "cancel" ? "line-through" : "";
          const isLatestRow = getIsLatestRow(tableMeta);
          return (
            <Box
              className={className}
              sx={{
                color: isLatestRow ? "text.warning" : "",
                fontWeight: isLatestRow ? "bold" : "normal"
              }}
            >
              {`${value?.toLocaleString("en-US") || 0} VNĐ`}
            </Box>
          );
        }
      }
    },
    {
      name: "createdAt",
      label: "Ngày góp",
      hasFilter: false,
      options: {
        customBodyRender: (value, tableMeta) => {
          const status = tableMeta.rowData[0];
          const className = status === "cancel" ? "line-through" : "";
          const isLatestRow = getIsLatestRow(tableMeta);
          const valueText = isLatestRow
            ? ""
            : dayjs(value).format("DD/MM/YYYY");
          return <Box className={className}>{valueText}</Box>;
        }
      }
    },
    {
      name: "type",
      label: "Loại vốn",
      options: {
        customBodyRender: (value, tableMeta) => {
          const isLatestRow = getIsLatestRow(tableMeta);
          const valueText = isLatestRow ? "" : investTypes[value];
          const status = tableMeta.rowData[0];
          const className = status === "cancel" ? "line-through" : "";
          return <Box className={className}>{valueText}</Box>;
        }
      }
    },
    {
      name: "note",
      label: "Ghi chú"
    },
    {
      name: "status",
      label: "Tình trạng",
      options: {
        customBodyRender: (value, tableMeta) => {
          const status = tableMeta.rowData[0];
          const className = status === "cancel" ? "line-through" : "";
          const isLatestRow = getIsLatestRow(tableMeta);
          const valueText = isLatestRow ? "" : "Đang đầu tư";
          return <Box className={className}>{valueText}</Box>;
        }
      }
    },
    {
      name: "id",
      label: "Chức năng",
      hasFilter: false,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { textAlign: "center", width: "100px" }
        }),
        customBodyRender: (value, tableMeta) => {
          const status = tableMeta.rowData[0];
          if (status === "inactive") {
            return null;
          }
          const isLatestRow = getIsLatestRow(tableMeta);
          const item = list.find(p => p.id === value);
          if (isLatestRow) {
            return null;
          }
          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <RouterLink
                className="mr-1 rounded-full bg-warning text-action-color p-2"
                onClick={event => handleDelete(event, "Hủy nguồn vốn", item.id)}
                to="#"
              >
                <Tooltip title="Hủy" placement="top">
                  <XSquareIcon size={16} />
                </Tooltip>
              </RouterLink>
            </Box>
          );
        }
      }
    }
  ];
  return (
    <>
      <Title id="Hợp đồng Vốn" />
      {openEdit && (
        <CapitalEdit
          open={openEdit}
          handleClose={handleCloseEdit}
          data={dataEdit}
        />
      )}
      <CapitalAdd open={open} handleClose={handleClose} />
      <ConfirmationDialog
        open={openModalDelete}
        handleClose={handleCloseModalDelete}
        onSubmit={() => remove(deleteId)}
        title="Hủy"
        confirmTitle={`Bạn có chắc chắn ${deleteModalContent.toLowerCase()} này không?`}
        content={deleteModalContent}
      />
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Button
            color="primary"
            className="customButton"
            variant="contained"
            onClick={handleOpen}
            size="small"
          >
            Thêm mới
          </Button>
          <Box sx={{ pt: 3 }}>
            {loading ? (
              <CustomLinearProgress />
            ) : (
              <CustomTable
                title={
                  <Typography variant="h2">
                    Hợp đồng góp vốn cửa hàng
                  </Typography>
                }
                data={list}
                options={options}
                columns={columns}
                id="hop-dong-von"
              />
            )}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Capital;
